import styled from 'styled-components';
import WashingMachineSvg from '../../assets/amenities/washing-machine.svg';

const WashingMachineIcon = styled(WashingMachineSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default WashingMachineIcon;
